import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDI } from '@/di/DIContext'
import { useUserProfile } from '@/presentation/hooks/useUserProfile'

export function useEditNickname() {
  const navigate = useNavigate()
  const { accountService, sessionService } = useDI()
  const { userProfile: userData, isUserProfileLoading: isProfileLoading } =
    useUserProfile()

  const [nickname, setNicknameValue] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const userNickname = userData?.nickname || ''

  useEffect(() => {
    if (userNickname) {
      setNicknameValue(userNickname)
    }
  }, [userNickname])

  const agentId = sessionService.getAgentId()

  const handleSave = async () => {
    setIsLoading(true)
    setErrorMessage('')
    try {
      await accountService.updateNickname(agentId!, nickname.trim())
      navigate('/me', { replace: true })
    } catch (error) {
      const err = error as Error
      setErrorMessage(err.message)
    } finally {
      setIsLoading(false)
    }
  }

  const handleClear = () => {
    setNicknameValue('')
  }

  const canSave = nickname.trim().length > 0 && nickname !== userNickname

  const setNickname = (value: string) => {
    setNicknameValue(value)
    if (errorMessage) setErrorMessage('')
  }

  return {
    nickname,
    setNickname,
    isLoading: isLoading || isProfileLoading,
    errorMessage,
    handleSave,
    handleClear,
    canSave,
  }
}
